import { Grid, List as ListIcon } from '@boxicons/react';
import { LevelViewType } from '../../context/app/AppContext';
import { useApp } from '../../context/app/useApp';

interface Props {
    className?: string;
}

export default function LevelViewToggle({ className }: Props) {
    const app = useApp();
    const isListView = app.levelViewType === LevelViewType.LIST;

    return (
        <button
            type='button'
            className={
                'inline-flex h-9 items-center gap-1 text-theme-400 hover:text-theme-text transition-colors' +
                (className ? ' ' + className : '')
            }
            onClick={() => app.set('levelViewType', isListView ? LevelViewType.GRID : LevelViewType.LIST)}
        >
            {isListView ? (
                <>
                    List <ListIcon />
                </>
            ) : (
                <>
                    Grid <Grid />
                </>
            )}
        </button>
    );
}
